export default __webpack_public_path__ + "static/media/hk.5043f05f.svg";